import van from './van.svg';
import moto from './moto.svg';

export default {
  van,
  moto,
};
